export default Object.freeze({
  url: {
    offerService: {
      baseUrl: process.env.VUE_APP__OFFER_SERVICE__BASE_URL,
      api: {
        offersUpload: '/api/v1/offers/upload',
        getOffers: '/api/v1/offers',
        getActiveOffers: '/api/v1/offers?filter[active]=true',
        postBid: '/api/v1/bids',
        deactivateAllOffers: '/api/v1/offers/actions/deactivate-offers',
        setActiveState: '/api/v1/offers/actions/set-active-state',
        purchaseOffers: {
          create: '/api/v1/purchase-offers',
          accept: '/api/v1/accept/purchase-offers',
          fail: '/api/v1/fail/purchase-offers',
          block: '/api/v1/block/purchase-offers',
          unblock: '/api/v1/unblock/purchase-offers',
          lastUpdateTimestamp: '/api/v1/last-update/purchase-offers',
          get: '/api/v1/purchase-offers',
          getStock: '/api/v1/purchase-offers',
          getAccepted: '/api/v1/accepted-purchase-offers',
          reject: '/api/v1/reject/purchase-offer',
          getOffersByOfferId: '/api/v1/purchase-offers/byPurchaseOfferId',
          upload: '/api/v1/purchase-offers/upload',
          uploads: '/api/v1/purchase-offers/uploads',
          importLog: '/api/v1/purchase-offers/import-log',
          downloadStockFile: (fileName) => `/api/v1/purchase-offers/download/stock-file/${fileName}`,
          downloadImportLog: (fileName) => `/api/v1/purchase-offers/download/import-log/${fileName}`,
          downloadErrorLog: (fileName) => `/api/v1/purchase-offers/download/error-log/${fileName}`,
        },
        offers: {
          get: '/api/v1/offers',
          getActive: '/api/v1/offers?filter[active]=true',
          upload: '/api/v1/offers/upload',
          deactivateAll: '/api/v1/offers/actions/deactivate-offers',
          setActiveState: '/api/v1/offers/actions/set-active-state',
        },
        bids: {
          post: '/api/v1/bids',
        },
      },
    },
    userService: {
      baseUrl: process.env.VUE_APP__USER_SERVICE__BASE_URL,
      api: {
        login: '/api/v1/auth/login',
        token: '/api/v1/auth/token',
        postUsers: '/api/v1/users',
        resetPassword: '/api/v1/users/actions/reset-password',
        users: '/api/v1/users',
        suppliers: '/api/v1/suppliers',
        matchSupplier: (userId, supplierId) => `/api/v1/users/${userId}/suppliers/${supplierId}`,
        byCreditor: (creditorId) => `/api/v1/user/byCreditor/${creditorId}`,
      },
    },
    purchaseOrderService: {
      baseUrl: process.env.VUE_APP__PURCHASE_ORDER_SERVICE__BASE_URL,
      api: {
        orders: '/api/v1/purchase_orders',
        ordersInDateRange: () => `/api/v1/purchase_orders`,
      },
    },
    demandService: {
      baseUrl: process.env.VUE_APP__DEMAND_SERVICE__BASE_URL,
      api: {
        getActiveDemands: '/v3/demands',
        getAdminDemands: '/v3/demands',
        getDemandsGroupedBySku: '/v3/demands-sku',
        getLastUpdateTimestamp: '/v3/last-update/demands',
        createStrategicDemand: '/v3/strategic-demands',
        fulfillDemand: '/v4/fulfill',
        cancelDemand: (demandId) => `/v4/cancel/${demandId}`,
        getDemandsByDemandIds: '/v4/demands/byDemandId',
      },
    },
  },
  DATE_FORMAT: 'yyyy-MM-dd',
});
